import { FC } from 'react';
import { Route } from 'react-router-dom';
import Layout from '../layout';
import { IRoute } from '../types';

const PermittedRoute: FC<IRoute> = (props) => {

  const {
    path,
    Component,
    layout,
    title,
    subtitle,
    ...rest
  } = props;

  if (!Component)
    throw new Error('no Component for route');

  return (
    <Route
      {...rest}
      exact
      path={path}
      render={(routeProps) => (
        <Layout layout={layout} title={title} subtitle={subtitle}>
          <Component {...routeProps} />
        </Layout>
      )}
    />
  );

};

export default PermittedRoute;
